import { Injectable } from '@angular/core';
import {
    ScrollToService,
    ScrollToConfigOptions
} from '@nicky-lenaers/ngx-scroll-to';
import { Observable } from 'rxjs';
@Injectable()
export class ScrollService {
    constructor(private _scrollToService: ScrollToService) {}
    public _init(duration = 500) {
        const config: ScrollToConfigOptions = {
            offset: -84,
            target:  'content-wrapper',
            duration: duration
        };
        this._scrollToService.scrollTo(config);
    }

    public _scrollTo(id, offset = -84): Observable<any> {
        const config: ScrollToConfigOptions = {
            offset: offset,
            target: id,
            duration: 500
        };
        return this._scrollToService.scrollTo(config);
    }
}
